import React from 'react';
import Dialog from '../Dialog';

interface DeleteJobsiteDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    deleteReason: string;
    setDeleteReason: (reason: string) => void;
    deleteReasonError: string;
    setDeleteReasonError: (error: string) => void;
}

const DeleteJobsiteDialog: React.FC<DeleteJobsiteDialogProps> = ({
    isOpen,
    onClose,
    onConfirm,
    deleteReason,
    setDeleteReason,
    deleteReasonError,
    setDeleteReasonError
}) => {
    const handleClose = () => {
        onClose();
        setDeleteReason('');
        setDeleteReasonError('');
    };

    return (
        <Dialog
            id="delete-jobsite-dialog"
            isOpen={isOpen}
            onClose={handleClose}
            width="w-[450px]"
            padding="px-10 py-10"
            className="z-[60]"
            hideCloseButton={true}
            disableBackdropClick={true}
        >
            <div className="text-center">
                <h3 className="text-xl font-bold mb-2">Are you sure to Delete the Jobsite?</h3>
                <p className="text-gray-600 mb-4">Please provide a reason for deletion</p>

                <div className="mb-6">
                    <textarea
                        className={`w-full px-4 py-3 text-sm border ${deleteReasonError ? 'border-red-500' : 'border-gray-300'} rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-black focus:border-black min-h-[100px]`}
                        placeholder="Enter reason for deletion..."
                        value={deleteReason}
                        onChange={(e) => {
                            setDeleteReason(e.target.value);
                            if (e.target.value.trim()) {
                                setDeleteReasonError('');
                            }
                        }}
                        id="delete-reason-textarea"
                    />
                    {deleteReasonError && (
                        <p className="text-sm text-red-600 text-left mt-1">{deleteReasonError}</p>
                    )}
                </div>

                <div className="flex justify-center gap-4">
                    <button
                        id="btn-delete-cancel"
                        onClick={handleClose}
                        className="btn-secondary px-8 py-2"
                    >
                        No
                    </button>
                    <button
                        id="btn-delete-confirm"
                        onClick={onConfirm}
                        className={`btn-primary text-white px-8 py-2 ${!deleteReason.trim() ? 'opacity-50 cursor-not-allowed' : ''}`}
                        disabled={!deleteReason.trim()}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default DeleteJobsiteDialog; 